import './content-pages';
import blocks from './blocks';
import { App } from 'vue';

export default function config(app: App) {
    blocks(app);
}
